// storybook-check-ignore
import React from 'react';
import { useTranslation } from 'react-i18next';

import { css } from '@emotion/react';
import { Box as NovoBox, Text } from '@opendoor/bricks-next';
import Box from '@opendoor/bricks/core/Box';

import cosmosI18n from '../../../../i18n/config';
import AccountMenu from '../../../account/AccountMenu';
import { defaultEaseCss } from '../motion/MotionVariants';
import { LoginSection } from './LoginSection';

interface AccountSectionProps {
  isLoggedIn: boolean;
  showLogin: boolean;
  firstName: string;
  initials: string[] | (string | undefined)[];
  isExpanded: boolean;
  handleAccountClick: () => void;
}

export const AccountSection: React.FC<AccountSectionProps> = ({
  isLoggedIn,
  showLogin,
  firstName,
  initials,
  isExpanded,
  handleAccountClick,
}) => {
  const { t } = useTranslation('homepage', { i18n: cosmosI18n });

  return (
    <Box
      onClick={handleAccountClick}
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {isLoggedIn ? (
        <Box
          display="inline-flex"
          cursor="pointer"
          fontWeight="medium"
          gap="4px"
          _hover={{
            color: 'brandBlue600',
          }}
        >
          <Box>
            <Text tag="span" $smallerThanMD={{ display: 'none' }} typography="$labelMedium">
              {t('titles.welcome', 'Welcome')} {firstName}
            </Text>
            <Text
              tag="span"
              typography="$labelSmall"
              $largerThanSM={{ display: 'none' }}
              borderRadius="$60x"
              backgroundColor="$backgroundInversePrimary"
              color="$contentInversePrimary"
              p={10}
            >
              {initials}
            </Text>
          </Box>
          <NovoBox width={24} height={24} position="relative" $smallerThanMD={{ top: 3 }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              style={{
                position: 'absolute',
                transition: `0.15s ${defaultEaseCss} transform`,
                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0)',
                transformOrigin: 'center',
                left: '50%',
                top: '50%',
                margin: '-4px 0 0 -7px',
              }}
            >
              <path
                d="M13 0.999999L7 7L1 1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </NovoBox>
          <Box
            position="absolute"
            top="-35px"
            css={css`
              right: -35px;
              @media (max-width: 1201px) {
                right: -30px;
              }
              @media (max-width: 767px) {
                right: -20px;
                left: inherit;
              }
            `}
          >
            <AccountMenu isExpanded={isExpanded} />
          </Box>
        </Box>
      ) : (
        <LoginSection showLogin={showLogin} />
      )}
    </Box>
  );
};
